<style lang="scss" scoped>
  $green: rgb(39, 174, 96) !default;

  .card {
    font-size: 14px;

    h2 {
      line-height: 28px;
      font-size: 20px;
      font-family: Lato;
      font-weight: 300;
      margin-bottom: 15px;
    }
  }

  .black {
    color: #000;
  }

  .fs-11 {
    font-size: 11px;
  }

  .line-through {
    text-decoration: line-through;
  }

  .shadow {
    box-shadow: 0 10px 20px rgba(165, 131, 224, 0.18);
  }

  .btn-helpers {
    height: 32px;
    padding: 10px;
    color: #f6f5f8;
    font-size: 11px;
    line-height: 13px;
    font-weight: 700;
  }

  a {
    &:hover {
      color: $green;
    }
  }

  .d-flex.bg-white {
    height: 193px;
    border-radius: 15px;
  }

  .timeline-label:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .bg-light-gray {
    background-color: #edeaf0;
    border-radius: 10px 10px 0px 0px;
  }

  .rounded-right-tb {
    border-radius: 0px 20px 20px 0px;
  }

  .rounded-left-tb {
    border-radius: 20px 0px 0px 20px;
  }

  .rounded-20 {
    border-radius: 20px;
  }

  .rounded-t-10 {
    border-radius: 10px 10px 0px 0px;
  }

  .rounded-10 {
    border-radius: 10px;
  }

  .progress-card {
    height: 158px;
    border-radius: 15px;
    background-color: #1e1a26;
    box-shadow: 0 10px 20px rgba(165, 131, 224, 0.18);

    .progress-settings {
      height: 23px;
      display: flex;
      overflow: hidden;
      font-size: 0.5625rem;
      background-color: #3b334a;
      border-radius: 0.25rem;
    }

    .progress-line {
      height: 28px;
      border-right: 1px solid #2ceba9;
      background-color: transparent;
      color: #2ceba9;
      min-width: 2%
    }

    .progress-line span {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.2px;
      line-height: 30px;
    }

    .bg-progress {
      background-color: #2ceba9;
    }
  }

  .contact-email {
    font-size: 11px;
    color: #3b334a;
    font-weight: 400;
    letter-spacing: 0.22px;
    line-height: 18px;

    .send-email {
      color: #7123db;
      text-decoration: underline;
    }
  }

  .progress-card-label {
    height: 25px;
    color: #f6f5f8;
    font-weight: 400;
    letter-spacing: 0.24px;
    line-height: 30px;
    font-size: 12px;
  }

  .about-bulldesk-icon {
    background-image: url(/build/icons/learn-about-check@register.png)
  }

  .manage-campaign {
    background-image: url(/build/images/auth/bg_settings_whats@2x.png);
    height: 274px;
    background-size: cover;
    border-radius: 0 0 8px 8px;
  }

  .description-campaign {
    padding: 5.5rem 30px;
    font-size: 12px;
    color: #FFF;
  }

  .btn-campaign {
    border: 1px solid #f6f5f8;
    padding: 10px 18px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    line-height: 13px;
    color: #f6f5f8;
    background: transparent;
  }

  .description-campaign h4 {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.27px;
  }

  .timeline-centered.setup {
    font-family: 'Open Sans';
    font-weight: 300;
    font-size: 14px;
    margin-top: 0;

    &:before {
      margin-left: 35px;
      background: #AEBDCC;
      // background: $green;
      // background: #f0f4f7;
      // background: #999
      opacity: .5;
    }

    .timeline-icon {
      background-color: #fff;
      color: $green;
      // color: #d9e0e7;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      line-height: 47px;
      font-size: 25px;
      // border: 1px solid $green;

      &:not(.done) {
        color: #444;
        // border: 1px solid #555;
      }

      &.done {
        background: $green;
        color: #fff;
        // color: #444;
        // border: 1px solid #444;
      }
    }

    .timeline-entry {
      margin-bottom: 10px;
    }

    .timeline-entry-inner {
      margin-bottom: 10px;
    }

    .timeline-group,
    .timeline-label {
      margin-left: 70px;
    }

    .timeline-group {
      h2 {
        font-size: 20px;
        font-family: Lato;
        font-weight: 300;
      }
    }

    .timeline-label {
      padding: 0;
      margin-top: 10px;
      background-color: #fff;

      border-radius: 3px;
      background-color: #fff;
      border: 1px solid #c9d7df;
      min-height: 0;
      max-width: 600px;
      transition: all .15s linear;
      text-decoration: none;

      .label-inner {
        padding: 10px;
        // padding-left: 15px;

        .timeline-icon {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          margin-top: 4px;
        }

        .timeline-group {
          margin-left: 55px;
          font-size: 13px;

          h2 {
            color: #444;
            font-size: 16px;
            margin-bottom: 3px;
            // margin-bottom: 0;
          }
        }
      }
    }
  }

  .timeline-header span {
    font-size: 11px;
  }
  .course {
    margin: 3rem 8rem;
  }
  .progressbar {
    min-width: 2%;
  }
  @media (max-width: 1280px) {
    .description-campaign {
      padding: 3.5rem 30px;
    }
    .btn-campaign {
      padding: 10px 14px;
    }
  }
  @media (max-width: 1120px) {
    .description-campaign {
      padding: 2rem 15px;
    }
  }
</style>

<template>
  <div class="row bg-white mt-4 shadow rounded-20">
    <div class="col-md-8 p-4 bg-white rounded-left-tb">
      <div class="h4">
        {{ __('Começando com o Salesflow') }}
        <div class="progress-card align-items-center mt-4">
          <div class="col-md-12 pt-4 p-4">
            <div class="progress-card-label">
              <span>{{ __('Progresso') }}...</span>
            </div>
            <div
              class="progress-line text-right pr-2"
              role="progressbar"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="{ width: progress * 100 + '%' }"
            >
              <span>{{ progress | percent(0) }}</span>
            </div>
            <div class="progress-settings rounded-pill">
              <div
                class="progress-bar bg-progress"
                role="progressbar"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: progress * 100 + '%' }"
              />
            </div>
          </div>
        </div>
      </div>
      <article
        class="timeline-entry"
        v-for="group in setup.groups"
      >
        <div class="mt-4 shadow">
          <div class="bg-light-gray rounded-t-10">
            <div
              class="timeline-icon"
              :class="{ done: group.done }"
            >
              <div class="row p-4 align-items-center">
                <div
                  class="col-md-1 icon"
                  v-if="group.done"
                >
                  <img
                    src="/build/icons/learn-about-check@2x.png"
                    width="31"
                  >
                </div>
                <div
                  class="col-md-1 icon"
                  v-else
                >
                  <img
                    src="/build/icons/learn-about@2x.png"
                    width="31"
                  >
                </div>
                <div class="col-8 timeline-header pl-0">
                  <div class="h4 mb-0">
                    {{ group.name }}
                  </div><span>{{ group.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white shadow timeline-label"
          v-for="(step, index) in group.steps"
        >
          <div
            class="timeline-icon"
            :class="{ done: step.done }"
          >
            <div
              class="row p-4 align-items-center"
              v-if="step.done"
            >
              <div class="col-md-1 icon">
                <img
                  class="ml-2"
                  src="/build/icons/task-check@2x.png"
                  height="16"
                >
              </div>
              <div class="col-8 pl-0">
                <div class="h6 mb-0 line-through">
                  {{ step.name }}
                </div>
              </div>
              <div class="col-md-3 text-right">
                <a
                  :href="step.action.destination"
                  target="_blank"
                  :title="step.name"
                  @click="complete(step)"
                  v-if="redirect(step)"
                ><span
                  class="btn btn-purple btn-helpers"
                  v-if="step.description=== 'Ver FAQ'"
                >{{ step.description }}</span><span v-else>{{ step.description }}</span></a><a
                  href="#"
                  :title="step.name"
                  @click.prevent="call(step)"
                  v-else
                ><span>{{ step.description }}</span></a>
              </div>
            </div>
            <div
              class="row p-4 align-items-center"
              v-else
            >
              <div class="col-md-1 icon">
                <img
                  class="ml-2"
                  src="/build/icons/task@2x.png"
                  height="16"
                >
              </div>
              <div class="col-8 pl-0">
                <div class="h6 mb-0">
                  {{ step.name }}
                </div>
              </div>
              <div class="col-md-3 text-right">
                <a
                  :href="step.action.destination"
                  target="_blank"
                  :title="step.name"
                  @click="complete(step)"
                  v-if="redirect(step)"
                ><span>{{ step.description }}</span></a><a
                  href="#"
                  :title="step.name"
                  @click.prevent="call(step)"
                  v-else
                ><span>{{ step.description }}</span></a>
              </div>
            </div>
          </div>
          <div
            class="w-100"
            v-if="index == group.steps.length - 1"
          />
          <hr
            class="w-100 mt-0 mb-0"
            v-else
          >
        </div>
      </article>
    </div>
    <div class="col-md-4 p-4 bg-light-gray rounded-right-tb">
      <h4>{{ __('Com dúvidas') }}?</h4>
      <div class="bg-white rounded-10 shadow">
        <div class="col-md-12 pt-4 mt-4 p-4">
          <h5>{{ __('Clique nos links para ter ajuda') }}</h5><span class="contact-email">{{ __('Se tiver alguma dúvida que não foi relacionado aqui') }},&nbsp<a
            class="send-email"
            href="mailto:atendimento@salesflowcrm.movidesk.com"
          >{{ __('nos envie um e-mail') }}.</a></span>
          <div class="pt-4">
            <a
              href="https://salesflowcrm.movidesk.com/kb"
              target="_blank"
            >
              <button
                class="btn btn-purple btn-helpers"
                type="button"
              >{{ __('Central de ajuda') }}</button></a>
          </div>
          <div class="pt-2">
            <a
              href="https://salesflowcrm.movidesk.com/kb/article/403761/api"
              target="_blank"
            >
              <button
                class="btn btn-purple btn-helpers"
                type="submit"
              >{{ __('Documentação API') }}</button></a>
          </div>
          <div class="pt-2 pb-3">
            <a
              href="https://salesflowcrm.movidesk.com/kb/article/402892/integracoes"
              target="_blank"
            >
              <button
                class="btn btn-purple btn-helpers"
                type="submit"
              >{{ __('Documentação Integrações') }}</button></a>
          </div>
        </div>
      </div>
    <!-- hr.mt-0.mb-0-->
    <!--   .col-md-12.pt-4.mt-2.p-4-->
    <!--     h5 Automatize com WhatsApp!-->
    <!--     .fs-11 Você já conhece nossa ferramenta de automação através do Whatsapp? Clique no banner para descobrir como funciona.-->
    <!--.col-md-12.manage-campaign-->
    <!-- .col-md-12.description-campaign-->
    <!--   h4 Gerencie campanhas dentro do próprio WhatsApp e obtenha ainda mais sucesso com seus clientes.-->
    <!--   button.btn-campaign Clique aqui para saber mais-->
    <!-- .col-md-12.course-->
    <!-- a(href="#")-->
    <!--   img(src="/build/icons/whatsapp.svg" style="height: 15rem")-->
    </div>
    <!-- Account data-->
    <BModal
      id="company-data-modal"
      ref="company-data-modal"
      hide-footer="hide-footer"
      modal-class="modal-max-width-720"
    >
      <template slot="modal-title">
        {{ __('Dados da Conta') }}
      </template>
      <template slot="default">
        <form
          class="form"
          role="form"
        >
          <div class="row">
            <div class="col-md-6">
              <div
                class="form-group"
                :class="{ 'has-error': account.errors.has('name') }"
              >
                <label>{{ __('Nome') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="account.name"
                ><span
                  class="form-text"
                  v-show="account.errors.has('name')"
                >{{ account.errors.get('name') }}</span>
              </div>
              <div
                class="form-group"
                :class="{ 'has-error': account.errors.has('document') }"
              >
                <label>{{ __('CNPJ') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="document"
                  v-model="account.document"
                  v-mask="'##.###.###/####-##'"
                  :placeholder="__('Digite seu CNPJ')"
                ><span
                  class="form-text"
                  v-show="account.errors.has('document')"
                >{{ account.errors.get('document') }}</span>
              </div>
              <div
                class="form-group"
                :class="{ 'has-error': account.errors.has('contact') }"
              >
                <label>{{ __('Responsável') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="contact"
                  v-model="account.contact"
                  :placeholder="__('Nome do responsável pela empresa')"
                ><span
                  class="form-text"
                  v-show="account.errors.has('contact')"
                >{{ account.errors.get('contact') }}</span>
              </div>
              <div
                class="form-group"
                :class="{ 'has-error': account.errors.has('email') }"
              >
                <label>E-mail</label>
                <input
                  class="form-control"
                  type="email"
                  name="email"
                  v-model="account.email"
                  :placeholder="__('E-mail do responsável pela empresa')"
                ><span
                  class="form-text"
                  v-show="account.errors.has('email')"
                >{{ account.errors.get('email') }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="form-group row"
                :class="{ 'has-error': account.errors.has('billing_address') }"
              >
                <div class="col-md-8">
                  <label>{{ __('Rua') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="billing_address"
                    v-model="account.billing_address"
                    :placeholder="__('Rua')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('billing_address')"
                  >{{ account.errors.get('billing_address') }}</span>
                </div>
                <div class="col-md-4">
                  <label>{{ __('Número') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="billing_address_line_2"
                    v-model="account.billing_address_line_2"
                    :placeholder="__('Número')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('billing_address_line_2')"
                  >{{ account.errors.get('billing_address_line_2') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label>{{ __('Complemento') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="extra_billing_information"
                    v-model="account.extra_billing_information"
                    :placeholder="__('Complemento')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('extra_billing_information')"
                  >{{ account.errors.get('extra_billing_information') }}</span>
                </div>
                <div class="col-md-6">
                  <label>{{ __('Bairro') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="billing_district"
                    v-model="account.billing_district"
                    :placeholder="__('Bairro')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('billing_district')"
                  >{{ account.errors.get('billing_district') }}</span>
                </div>
              </div>
              <div
                class="form-group"
                :class="{ 'has-error': account.errors.has('billing_city') }"
              >
                <label>{{ __('Cidade') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="billing_city"
                  v-model="account.billing_city"
                  :placeholder="__('Cidade')"
                ><span
                  class="form-text"
                  v-show="account.errors.has('billing_city')"
                >{{ account.errors.get('billing_city') }}</span>
              </div>
              <div
                class="form-group row"
                :class="{ 'has-error': account.errors.has('billing_zip') }"
              >
                <div class="col-md-8">
                  <label>{{ __('CEP') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="billing_zip"
                    v-model="account.billing_zip"
                    v-mask="'#####-###'"
                    :placeholder="__('CEP')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('billing_zip')"
                  >{{ account.errors.get('billing_zip') }}</span>
                </div>
                <div class="col-md-4">
                  <label>{{ __('Estado') }}</label>
                  <input
                    class="form-control"
                    type="text"
                    name="billing_state"
                    v-model="account.billing_state"
                    :placeholder="__('Estado')"
                  ><span
                    class="form-text"
                    v-show="account.errors.has('billing_state')"
                  >{{ account.errors.get('billing_state') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="form-group m-b-0"
                v-if="account.terms == false"
              >
                <label class="form-check-label">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="account.terms"
                    value="true"
                  > {{ __('Eu aceito os') }}<a
                    href="https://salesflowcrm.movidesk.com/kb/article/405957/termos-de-uso"
                    target="_blank"
                  >{{ __('termos de uso') }}</a>.
                </label><span
                  class="form-text text-danger"
                  v-show="account.errors.has('terms')"
                >{{ account.errors.get('terms') }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-box-success"
              type="submit"
              @click.prevent="saveAccount()"
              :disabled="account.busy"
            >
              {{ __('Salvar') }}
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <!-- Add domain-->
    <BModal
      id="mail-domain-modal"
      ref="mail-domain-modal"
      hide-footer="hide-footer"
      modal-class="modal-width-400"
    >
      <template slot="modal-title">
        {{ __('Adicione seu domínio para enviar e-mails') }}
      </template>
      <template slot="default">
        <form
          class="form"
          role="form"
        >
          <p class="form-text">
            {{ __('Adicione o domínio de sua empresa para enviar e-mails pelo Bulldesk') }}.
          </p>
          <div
            class="form-group"
            :class="{ 'has-error': mail.errors.has('domain') }"
          >
            <label>{{ __('Domínio') }}</label>
            <input
              class="form-control"
              type="text"
              v-model="mail.domain"
              :placeholder="__('suaempresa.com.br')"
              pattern="^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,13}$"
            ><span
              class="form-text"
              v-show="mail.errors.has('domain')"
            >{{ mail.errors.get('domain') }}</span>
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-box-success"
              type="submit"
              @click.prevent="addDomain()"
              :disabled="mail.busy"
            >
              {{ __('Adicionar') }}
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <SettingsVerifyDomain />
    <BModal
      id="setup-modal"
      ref="setup-modal"
      hide-footer="hide-footer"
      modal-class="modal-width-500"
    >
      <template slot="modal-title">
        {{ step.name }}
      </template>
      <template slot="default">
        <form
          class="form"
          role="form"
        >
          <div
            v-html="step.content"
            v-if="step.content"
          >
            <div>
              <p
                class="black"
                v-html="step.message"
                v-if="step.message && ! step.done"
              />
            </div>
          </div>
          <div
            class="modal-footer default-modal-footer"
            :class="{ 'done': step.done }"
          >
            <span v-if="step.status"><span
              class="float-left"
              v-if="step.done"
              v-html="step.status.done"
            /><span
              class="float-left"
              v-html="step.status.undone"
              v-else
            /></span>
            <button
              class="btn btn-box-success"
              type="submit"
              @click.prevent="verify()"
              :disabled="loading"
              v-if="! step.done"
            >
              <i
                class="fa fa-refresh"
                :class="{ 'fa-spin': loading }"
              />&nbsp;<span v-if="loading">{{ __('Verificando') }}...</span><span v-else>{{ __('Verificar') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { mask } from 'vue-the-mask';

export default {
  components: {
    BModal,
  },

  props: ['user'],

  directives: { mask },

  created () {
    this.getSetup();
    this.getDomains();

    Echo.channel(`tenant.${this.user.account}`)
      .listen('.Bulldesk\Tenant\Event\StepCompleted', (e) => {
        this.getSetup();
      });

    Bus.$on('verifyingDomain', (domain) => {
      if (domain) {
        Alert.info(`${this.__('Verificando ') + domain}...`);
      }
    });

    Bus.$on('domainVerified', (domain) => {
      Alert.success(`Domínio ${domain.identifier}${this.__(' verificado!')}`);

      this.getSetup();
    });
  },

  data () {
    return {
      loading: false,
      step: {},
      setup: { completed: 0, total: 0 },
      mail: new BulldeskForm({ domain: null }),
      account: new BulldeskForm({}),
    };
  },

  computed: {
    progress () {
      if (this.setup.total === 0 || ! this.setup.completed) {
        return 0;
      }

      const progress = this.setup.completed.length / this.setup.total;

      return progress > 1 ? 1 : progress;
    },
  },

  methods: {
    getSetup () {
      this.loading = true;

      this.$http.get('/settings/setup?ajax=true')
        .then((response) => {
          const { data } = response;
          const { account } = data;

          account.terms = true;

          if (account.address) {
            // Pass new relation as old fields.
            account.billing_zip = account.address.postalcode;
            account.billing_address = account.address.street;
            account.billing_address_line_2 = account.address.number;
            account.extra_billing_information = account.address.complement;
            account.billing_city = account.address.city;
            account.billing_district = account.address.district;
            account.billing_state = account.address.state;
            account.billing_country = account.address.country;
          }

          this.setup = data.setup;
          this.account = new BulldeskForm(account);

          if (this.step.identifier) {
            this.updateCurrentStep();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDomains () {
      this.$http.get('/settings/domain')
        .then((response) => {
          this.domains = response.data;

          const last = _.last(this.domains);

          if (last) {
            this.mail = new BulldeskForm({ domain: last.domain });
          }
        });
    },

    updateCurrentStep () {
      const current = this.step;

      for (let i = 0; i < this.setup.groups.length; i++) {
        const { steps } = this.setup.groups[i];

        for (let j = 0; j < steps.length; j++) {
          if (steps[j].identifier === current.identifier) {
            return this.step = steps[j];
          }
        }
      }
    },

    open (step) {
      this.step = step;

      const ref = `${step.identifier.replace('.', '-')}-modal`;

      if (this.$refs[ref]) {
        this.$refs[ref].show();

        return;
      }

      if (step.content) {
        this.$refs['setup-modal'].show();

        return;
      }

      console.warn(`Step ${step.identifier} has no content.`);
    },

    close () {
      this.step = {};

      Object.keys(this.$refs).forEach((key, index) => {
        if (key.includes('modal')) {
          try {
            this.$refs[key].hide();
          } catch (e) {

          }
        }
      });
    },

    verify () {
      if (! this.step.verify) {
        return this.getSetup();
      }

      this.loading = true;

      this.$http.post('/settings/setup/verify', { step: this.step.identifier, data: this.step.data })
        .then(() => {
          this.getSetup();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    complete (step) {
      this.$http.post('/settings/setup/complete', step)
        .then(() => {
          this.getSetup();
        });
    },

    redirect (step) {
      const action = step.action || {};

      return action.type === 'redirect';
    },

    saveAccount () {
      Http.put('/settings/setup/account', this.account)
        .then(() => {
          this.close();
          this.getSetup();
        });
    },

    addDomain () {
      Http.post('/settings/domain', this.mail)
        .then(() => {
          this.close();
          this.getSetup();

          this.verifyDomain();
        })
        .catch((response) => {
          Alert.error(this.__('Não foi possível adicionar este domínio.'));

          this.verifyDomain();
        });
    },

    verifyDomain () {
      if (! this.mail.domain) {
        this.$refs['mail-domain-modal'].show();

        return;
      }

      Bus.$emit('verifyDomain', { identifier: this.mail.domain });
    },

    call (step) {
      const action = step.action || {};

      switch (action.type) {
        case 'dispatch':
          return Bus.$emit(action.destination);
        case 'broadcast':
          return Bus.$emit(action.destination);
        case 'method':
          return this[action.destination]();
      }

      // Default is a modal.
      this.open(step);
    },
  },
};
</script>
